/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Headline_3Inputs */

const et_hero_headline_3 = /** @type {(inputs: Hero_Headline_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`90 `)
};

const en_hero_headline_3 = /** @type {(inputs: Hero_Headline_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`90 `)
};

/**
* | output |
* | --- |
* | "90" |
*
* @param {Hero_Headline_3Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_headline_3 = /** @type {((inputs?: Hero_Headline_3Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Headline_3Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_hero_headline_3(inputs)
	return en_hero_headline_3(inputs)
});